import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=46cc32bc&scoped=true&lang=pug"
import script from "./Loader.js?vue&type=script&lang=js&external"
export * from "./Loader.js?vue&type=script&lang=js&external"
import style0 from "./Loader.sass?vue&type=style&index=0&id=46cc32bc&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cc32bc",
  null
  
)

export default component.exports